import styles from "./WhatsAppBtn.module.css";

const WHATSAPP_URL =
  "https://wa.me/526461627265?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Sierra%20Vita";

export default function WhatsAppBtn() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      className={styles.whatsapp_btn}
      aria-label="WhatsApp Sierra Vita"
      title="WhatsApp Sierra Vita"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className={styles.whatsapp_icon}
        aria-hidden="true"
      >
        <path d="M19.11 17.21c-.27-.14-1.58-.78-1.82-.87-.24-.09-.41-.14-.58.14-.17.27-.67.87-.82 1.05-.15.18-.31.2-.58.07-.27-.14-1.13-.42-2.15-1.35-.8-.71-1.34-1.59-1.5-1.86-.15-.27-.02-.42.11-.55.12-.12.27-.31.41-.47.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.47-.07-.14-.58-1.41-.8-1.94-.21-.5-.43-.43-.58-.44h-.5c-.18 0-.47.07-.72.34s-.94.92-.94 2.24.96 2.61 1.1 2.79c.14.18 1.88 2.87 4.56 4.03.64.28 1.14.45 1.53.58.64.2 1.22.17 1.68.1.51-.08 1.58-.65 1.8-1.28.22-.63.22-1.17.15-1.28-.06-.11-.24-.18-.51-.32Z" />
        <path d="M16.03 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.59 4.47 1.71 6.42L3.2 28.8l6.54-1.72a12.77 12.77 0 0 0 6.29 1.65h.01c7.07 0 12.8-5.73 12.8-12.8S23.1 3.2 16.03 3.2Zm0 23.4h-.01a10.57 10.57 0 0 1-5.39-1.48l-.39-.23-3.88 1.02 1.04-3.78-.25-.39a10.6 10.6 0 1 1 8.88 4.86Z" />
      </svg>
    </a>
  );
}